export class LogoResponse {
    logo: string;

    constructor(logo: string) {
        this.logo = logo;
    }
}
